module.exports = __webpack_public_path__ + "static/img/papuga.30f8796f.webp";